import { createFileRoute } from '@tanstack/react-router'
import { ReportPage, reportSearches } from '@/features/analytics/index.ts'
import { usePersistedListQuery } from '@/hooks/use-persisted-list-query.ts'

const persistence = reportSearches.overview
export const Route = createFileRoute('/_authenticated/reports/')({
  validateSearch: persistence.validateSearch,
  beforeLoad: (options) => persistence.restore(options),
  component: Page,
  head: () => ({ meta: [{ title: '经营总览 · Super Mega' }] })
})
function Page() {
  const { currentSession } = Route.useRouteContext()
  const { search, navigateSearch } = usePersistedListQuery({
    persistence,
    raw: Route.useSearch(),
    accountId: currentSession.id,
    navigate: Route.useNavigate()
  })
  return <ReportPage dimension="organization" overview search={search} navigate={navigateSearch} />
}
